import { Injectable } from '@angular/core';
import { HttpService } from './http-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  userInfo: any;
  sharedData: any = [];
  userTerminals:any[];
  allTerminals:any[];
  constructor(private httpService: HttpService,) { }

  getUserInfo(type:any){
    return this.sharedData[type];
  }

  setUserInfo(res: any, type: any){
    this.sharedData[type] = res;
  }

  getTerminals(resData:any){
    return this.httpService.get(`${environment.apiEndpoint}/api/v1/jobmanager/fetchterminals?UserId=${resData.userId}&isAllTerminalRQ=${resData.isAllTermReq}`,'');
  }

  setAllTerminalList(terminalData:[]){
    this.allTerminals=terminalData;
  }

  getAllTerminalList(){
    return this.allTerminals;
  }

  setUserTerminalList(terminalData:[]){
    this.userTerminals=terminalData;
  }

  getUserTerminalList(){
    return this.userTerminals;
  }
}